export const sortArrayObject = (arr, key, order = "asc") => {
  if (order === "asc") {
    return arr.sort((a, b) => (a[key] > b[key] ? -1 : b[key] > a[key] ? 1 : 0));
  }

  return arr.sort((a, b) => (a[key] > b[key] ? 1 : b[key] > a[key] ? -1 : 0));
};

export const sortArrayObjectNumber = (arr, key) => {
  return arr.sort((a, b) => {
    return b[key] - a[key];
  });
};
